import { render, staticRenderFns } from "./MenuLateralSeccion.vue?vue&type=template&id=f209d744&scoped=true&"
import script from "./MenuLateralSeccion.vue?vue&type=script&lang=js&"
export * from "./MenuLateralSeccion.vue?vue&type=script&lang=js&"
import style0 from "./MenuLateralSeccion.vue?vue&type=style&index=0&id=f209d744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f209d744",
  null
  
)

export default component.exports